import VcsDetailsPage from "../../shared/VcsShared/components/VcsDetailsPage";

const BitbucketCloudDetailsPage = VcsDetailsPage;

export default BitbucketCloudDetailsPage;
